import { Button } from "@material-ui/core";
import React, { useRef, useEffect, useMemo, useState } from "react";

const LS_NAME = 'audioMessageRate';

const AUDIO_EXTENSION_PATTERN = /\.(mp3|ogg|oga|opus|wav|m4a|aac|mpeg|webm)(?:\?|$)/i;

const AudioModal = ({url}) => {
    const audioRef = useRef(null);
    const [audioRate, setAudioRate] = useState(parseFloat(localStorage.getItem(LS_NAME) || "1"));
    const [showButtonRate, setShowButtonRate] = useState(false);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const sourceUrl = useMemo(() => {
      if (!url) {
        return "";
      }

      if (isIOS && /\.ogg(?:\?|$)/i.test(url)) {
        return url.replace(/\.ogg(?=(?:\?|$))/i, ".mp3");
      }

      return url;
    }, [isIOS, url]);
  
    useEffect(() => {
      if (!audioRef.current) {
        return;
      }

      audioRef.current.playbackRate = audioRate;
      localStorage.setItem(LS_NAME, audioRate);
    }, [audioRate]);
  
    useEffect(() => {
      if (!audioRef.current) {
        return undefined;
      }

      audioRef.current.onplaying = () => {
        setShowButtonRate(true);
      };
      audioRef.current.onpause = () => {
        setShowButtonRate(false);
      };
      audioRef.current.onended = () => {
        setShowButtonRate(false);
      };
      return undefined;
    }, []);
  
    const toggleRate = () => {
      let newRate = null;
  
      switch (audioRate) {
        case 0.5:
          newRate = 1;
          break;
        case 1:
          newRate = 1.5;
          break;
        case 1.5:
          newRate = 2;
          break;
        case 2:
          newRate = 0.5;
          break;
        default:
          newRate = 1;
          break;
      }
  
      setAudioRate(newRate);
    };
  
    if (!sourceUrl || !AUDIO_EXTENSION_PATTERN.test(sourceUrl)) {
      return null;
    }
  
    return (
      <>
        <audio ref={audioRef} controls preload="metadata" src={sourceUrl}>
          Seu navegador nao suporta audio HTML5.
        </audio>
        {showButtonRate && (
          <Button
            style={{ marginLeft: "5px", marginTop: "-45px" }}
            onClick={toggleRate}
          >
            {audioRate}x
          </Button>
        )}
      </>
    );
}

export default AudioModal;
